module.exports = "/_next/static/images/og-sistema-com-eb0668915a196c76433a0ff2f10e852b.jpg";